// import main style dependency file
import "antd/dist/antd.min.css";
import "./i18n/index.tsx";
import "./index.css";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Authenticator from "./Authenticator";
import ErrorFallback from "./components/ErrorFallback";
import GlobalStyle from "./globalStyles";
import { initializeSentry, SentryErrorBoundary } from "./services/sentry";
import theme from "./theme";

// Initialize Sentry as early as possible
initializeSentry(process.env.REACT_APP_SENTRY_DSN || "");

const App = () => {
  return (
    <SentryErrorBoundary fallback={props => <ErrorFallback {...props} />}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Authenticator />
          <GlobalStyle />
        </BrowserRouter>
      </ThemeProvider>
    </SentryErrorBoundary>
  );
};

const rootEl = document.getElementById("root");

ReactDOM.render(<App />, rootEl);

if (module["hot"]) {
  module["hot"].accept(App, () => {
    ReactDOM.render(<App />, rootEl);
  });
}
